import { render, staticRenderFns } from "./GroupPurchasing.vue?vue&type=template&id=7edd5a73&scoped=true"
import script from "./GroupPurchasing.vue?vue&type=script&lang=js"
export * from "./GroupPurchasing.vue?vue&type=script&lang=js"
import style0 from "./GroupPurchasing.vue?vue&type=style&index=0&id=7edd5a73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd5a73",
  null
  
)

export default component.exports